export function applyWebAwesomeTheme(): void {
  const html = document.documentElement;
  html.classList.add('wa-theme-active');

  const applyDark = (dark: boolean): void => {
    html.classList.toggle('wa-dark', dark);
  };

  applyDark(window.matchMedia('(prefers-color-scheme: dark)').matches);
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
    applyDark(event.matches);
  });
}

export function isDarkTheme(): boolean {
  return document.documentElement.classList.contains('wa-dark');
}
